module.exports = __webpack_public_path__ + "img/icon_data4.e5fcc487.svg";